//CSS
import "../../Components/Page/Page.css";


//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

//Data
import QuoteComp from "../../Components/QuoteComp/QuoteComp";

const RevenueScenario: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="Revenue Scenario" />
            <SubSection>
                {/* <ImageComp imageSource={approach} width={"Clamp(18rem, 25vw, 36rem)"} /> */}
                {/* "Using one of the 25 global car companies (GM is #6) as an example – since Wankel in the 1960 licensed IP to all of them, – including to GM, a license for exclusivity and prototyping for $50-million, ($400-million in todays money)"} */}
                <QuoteComp text={"Using Wankel as an example, Wankel was able to leverage his IP to all 25 global car companies in 1960 into an exclusive $50-million licensing and prototyping deal with GM - $400-million in todays money."} />
                <div className="description-container">
                    <b>E-SPEC SaaS </b>
                    <p>
                        $1-million for 3 years. access to our continuously researched data and exlusive design tools to 
                        show the performance improvements of Elf-Tech innovations and its market advantages. 
                    </p>{" "}
                    <b>Parts’ CADs Sales From Our Growing Library</b>
                    <p>
                        $10-million for prototyping and building test engines, and $100-million for US 
                        exclusivity for 2 years if desired.
                    </p>{" "}
                    <b>Prototyping Licenses With or Without Exclusivity</b>
                    <p>
                        Prototyping licensees can explore how ELF-Tech innovations give their product 
                        the best edge in power, weight, efficiency, emissions and costs. ElF-Tech designs 
                        will become the “must use” global gold standard.
                    </p>{" "}
                    <b>Production Licenses</b>
                    <p>
                        A selection of Elf-Tech parts and engines from our extensive library of Computer Aided Designs.
                    </p>{" "}
                </div>
            </SubSection>
        </div>
    );
};

export default RevenueScenario;